import { createContext, useContext } from 'react';

interface TourContextType {
  activeTour: string | null;
  startTour: (tourId: string) => void;
  endTour: () => void;
  isTourActive: (tourId: string) => boolean;
}

export const TourContext = createContext<TourContextType | undefined>(undefined);

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};
